import { render, staticRenderFns } from "./subscribePerson.vue?vue&type=template&id=f241119a&scoped=true"
import script from "./subscribePerson.vue?vue&type=script&lang=js"
export * from "./subscribePerson.vue?vue&type=script&lang=js"
import style0 from "./subscribePerson.vue?vue&type=style&index=0&id=f241119a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f241119a",
  null
  
)

export default component.exports